import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { PdfRequest } from './pdf-request.interface';
import { first } from 'rxjs/operators';
import { saveAs } from 'file-saver';
import { Environment } from '../environment';

const httpOptions = {
  headers: new HttpHeaders({
    'Content-Type': 'application/json'
  }),
  responseType: 'blob' as 'json'
};

@Injectable({
  providedIn: 'root'
})
export class PdfService {
  constructor(private http: HttpClient, private env: Environment) {}

  populatePdf(request: PdfRequest, filename?: string) {
    const req = this.http.post(this.env.pdfApi, request, httpOptions);

    req.pipe(first()).subscribe(data => {
      if (filename) {
        saveAs(data, filename);
      } else {
        saveAs(data);
      }
    });

    return req;
  }
}
